import { render, staticRenderFns } from "./BlankAuth.vue?vue&type=template&id=4c39aaa2"
import script from "./BlankAuth.vue?vue&type=script&lang=js"
export * from "./BlankAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports